import { render, staticRenderFns } from "./EpicDetails.vue?vue&type=template&id=1c8ce097&"
import script from "./EpicDetails.vue?vue&type=script&lang=js&"
export * from "./EpicDetails.vue?vue&type=script&lang=js&"
import style0 from "./EpicDetails.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports